module.exports = __webpack_public_path__ + "img/brand(4).53719e08.png";